// extracted by mini-css-extract-plugin
export default {"xs":"ysGYU3","lg":"rKbTpl","title":"tRc1eg","gallery":"Ck8fkm","caption":"KYTGB1","accessibilityTheme":"LW5us7","accessibilityThemeLink":"HuXxfY"};